import { render, staticRenderFns } from "./RepeatDataReview.vue?vue&type=template&id=11ec0c90&scoped=true"
import script from "./RepeatDataReview.vue?vue&type=script&lang=js"
export * from "./RepeatDataReview.vue?vue&type=script&lang=js"
import style0 from "./RepeatDataReview.vue?vue&type=style&index=0&id=11ec0c90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ec0c90",
  null
  
)

export default component.exports